import { BusinessId } from "./generated/enums";
import { ApiUserPermissions } from "./permissions/user/api";

export enum RoleId {
    Master = 1,
    Admin = 2,
    Manager = 3,
    Agronomist = 4,
    Client = 5,
    Demo = 6,
    Access = 7,
    FmClient = 8,
    ScoutUser = 9,
    ConnectUser = 10,
    InvoicingAdmin = 11,
    ServiceSpecialist = 12,
    SoilMappingTeam = 13,
    ThirdPartyAgronomist = 14,
    AccessPlus = 15
}

export interface IOmniaUser {

    Id: number;

    Email: string;

    FirstName: string;
    LastName?: string;

    FactsNumber?: string;
    BasisNumber?: string;

    Role: RoleId

    BusinessId?: BusinessId

    Properties?: {

        Debug: boolean,
        AutoSelectContext: boolean,
        Services: string[]

    };

    Permissions: ApiUserPermissions,

    PhoneNumber: string;

    AutoSignupInProgress?: boolean
    PasswordResetRequested?: boolean

}
